import { SITE_URL } from 'env';

import { getElement } from '@app/utils';

const RECENT_SEARCHES_KEY = 'recentSearches';
const SUGGESTED_PAGES_ITEMS = [
  {
    title: 'User Guides',
    url: `${SITE_URL}user-guides/`,
    iconUrl: `${SITE_URL}images/icons/sections/user-guides-nav.svg`,
  },
  {
    title: 'DataPrime',
    url: `${SITE_URL}dataprime/`,
    iconUrl: `${SITE_URL}images/icons/sections/dataprime-nav.svg`,
  },
  {
    title: 'Integrations',
    url: `${SITE_URL}integrations/`,
    iconUrl: `${SITE_URL}images/icons/sections/integrations-nav.svg`,
  },
  {
    title: 'OpenTelemetry',
    url: `${SITE_URL}opentelemetry/`,
    iconUrl: `${SITE_URL}images/icons/sections/open-telemetry-nav.svg`,
  },
  {
    title: 'Developer Portal',
    url: `${SITE_URL}developer-portal/`,
    iconUrl: `${SITE_URL}images/icons/sections/developer-portal-nav.svg`,
  },
];

const setSearchToggle = (value: boolean): void => {
  const toggleEl = getElement('[data-md-toggle=search]') as HTMLInputElement;

  if (toggleEl.checked !== value) {
    toggleEl.click();
  }
};

const createRecentSearchesEl = () => {
  const recentSearchesEl = document.createElement('div');

  recentSearchesEl.classList.add('search-recent-searches');

  const recentSearchesHeaderEl =
    '<div class="recent-searches-header">Recent Searches</div>';

  let recentSearchesItems = '';
  const recentSearches =
    JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) as string) || [];

  if (!recentSearches.length) {
    return null;
  }

  recentSearches.reverse().forEach((item: string) => {
    recentSearchesItems += `<div class="recent-searches-item">${item}</div>`;
  });

  recentSearchesEl.innerHTML = recentSearchesHeaderEl + recentSearchesItems;

  return recentSearchesEl;
};

const createSuggestedPagesEl = () => {
  const suggestedPagesEl = document.createElement('div');

  suggestedPagesEl.classList.add('search-suggested-pages');

  const suggestedPagesHeaderEl =
    '<div class="suggested-pages-header">Suggested Pages</div>';

  let suggestedPagesItems = '';

  SUGGESTED_PAGES_ITEMS.forEach(({ title, url, iconUrl }) => {
    suggestedPagesItems += `<a href="${url}" class="suggested-pages-item"><img src="${iconUrl}" alt="${title} Icon">${title}</a>`;
  });

  suggestedPagesEl.innerHTML = suggestedPagesHeaderEl + suggestedPagesItems;

  return suggestedPagesEl;
};

const initSearchAdditionalElements = (searchInputEl: HTMLInputElement) => {
  const searchResultsEl = document.querySelector(
    '.md-header .md-search .md-search-result'
  ) as HTMLDivElement;

  const emptySearchEl = document.createElement('div');

  emptySearchEl.classList.add('empty-search');

  const recentSearchesEl = createRecentSearchesEl();

  if (recentSearchesEl) {
    emptySearchEl.appendChild(recentSearchesEl);
  }

  const noResultsEl = document.createElement('div');

  noResultsEl.classList.add('search-no-results', 'hidden');

  emptySearchEl.appendChild(noResultsEl);
  emptySearchEl.appendChild(createSuggestedPagesEl());

  searchResultsEl.appendChild(emptySearchEl);

  const recentSearchesEls = document.querySelectorAll('.recent-searches-item');

  recentSearchesEls.forEach((item) => {
    item.addEventListener('click', () => {
      searchInputEl.value = item.textContent as string;
      searchInputEl.dispatchEvent(new Event('keyup'));
      searchInputEl.focus();
    });
  });
};

const initRecentSearches = (searchInputEl: HTMLInputElement) => {
  const searchResultItems = document.querySelectorAll(
    '.md-search-result__item'
  );

  searchResultItems.forEach((item) => {
    item.addEventListener('click', () => {
      const recentSearches =
        JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) as string) || [];

      recentSearches.push(searchInputEl.value);
      const uniqueSearches = new Set(recentSearches.reverse());

      localStorage.setItem(
        RECENT_SEARCHES_KEY,
        JSON.stringify(Array.from(uniqueSearches).reverse().slice(-3))
      );
    });
  });
};

export const initSearch = () => {
  const searchEl = document.querySelector(
    '.md-header .md-search'
  ) as HTMLDivElement;

  if (!searchEl) {
    return;
  }

  const homeSearchEl = document.querySelector(
    '#home-search'
  ) as HTMLInputElement;

  const searchInputEl = document.querySelector(
    '.md-header .md-search .md-search__input'
  ) as HTMLInputElement;

  initSearchAdditionalElements(searchInputEl);

  searchEl.style.display = window.location.pathname === '/' ? 'none' : 'block';

  const activateSearch = () => {
    setSearchToggle(true);
    searchEl.classList.add('active');
  };

  const homeSearchInputEl = document.querySelector(
    '.home-search .md-search .md-search__input'
  ) as HTMLDivElement;

  if (homeSearchInputEl) {
    homeSearchInputEl.addEventListener('click', () => {
      activateSearch();
    });
  }

  const mobileSearchButtonEl = document.querySelector(
    '.header-search-button'
  ) as HTMLDivElement;

  if (mobileSearchButtonEl) {
    mobileSearchButtonEl.addEventListener('click', () => {
      activateSearch();
    });
  }

  if (searchInputEl) {
    const searchNoResultsEl = document.querySelector(
      '.search-no-results'
    ) as HTMLDivElement;

    searchInputEl.addEventListener('input', (e) => {
      const { value } = e.target as HTMLInputElement;

      searchNoResultsEl.textContent = `No matches for "${value}" were found.`;
    });

    searchInputEl.addEventListener('keyup', () => {
      const searchResultMetaEl = document.querySelector(
        '.md-header .md-search .md-search-result__meta'
      ) as HTMLDivElement;

      setTimeout(() => {
        const noResultsEl = document.querySelector(
          '.md-header .md-search .search-no-results'
        ) as HTMLDivElement;

        if (searchResultMetaEl.textContent === 'No matching documents') {
          noResultsEl.classList.remove('hidden');
        } else {
          noResultsEl.classList.add('hidden');
        }

        initRecentSearches(searchInputEl);

        const serchResultItemEls = document.querySelectorAll(
          '.md-search-result__item'
        );

        serchResultItemEls.forEach((item) => {
          const firstResultLinkArticle = item.querySelector(
            '.md-search-result__link:nth-of-type(1) .md-search-result__article'
          );
          const secondResultLinkArticle = item.querySelector(
            '.md-search-result__link:nth-of-type(2) .md-search-result__article'
          );

          if (firstResultLinkArticle && secondResultLinkArticle) {
            firstResultLinkArticle.innerHTML =
              firstResultLinkArticle.innerHTML +
              secondResultLinkArticle.innerHTML;

            secondResultLinkArticle.parentElement!.remove();
          }
        });
      }, 100);
    });
  }

  const homeSearchClearEl = searchEl.querySelector(
    '.md-search__options .md-search__icon'
  ) as HTMLElement;

  homeSearchClearEl.addEventListener('click', () => {
    searchInputEl.dispatchEvent(new Event('keyup'));
  });

  const headerOverlayEl = document.querySelector(
    '.md-header .md-search .md-search__overlay'
  ) as HTMLDivElement;

  if (searchEl) {
    searchEl.addEventListener('click', () => {
      activateSearch();
      searchEl.classList.add('active');
    });

    headerOverlayEl.addEventListener('click', (e) => {
      e.stopPropagation();
      setSearchToggle(false);
      searchEl.classList.remove('active');
    });

    document.addEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setSearchToggle(false);
        searchEl.classList.remove('active');
      }
    });
  }

  if (homeSearchEl) {
    homeSearchEl.addEventListener('click', () => {
      activateSearch();
      searchEl.classList.add('active');
    });
  }

  document.addEventListener('keyup', (e: KeyboardEvent) => {
    if (['f', '/'].includes(e.key)) {
      activateSearch();
    }
  });
};
